export const messageKeys = {
  base: ['message'],
  conversationMessages: (conversationID: string | undefined | null) => [
    ...messageKeys.base,
    conversationID,
    'conversationMessages',
  ],
};
